const isHttps = location.protocol == 'https:';
export default {
  token: undefined,
  enterprise: undefined,
  hosts: {
    host: !isHttps ? 'http://test-mc.meidd.com' : 'https://test-mc.meidd.com',
    mall: !isHttps ? 'http://test-api.meidd.com' : 'https://test-api.meidd.com'
  }
};



// WEBPACK FOOTER //
// ./src/config/testing.js